/** 極小的 className 合併工具，避免為了殼引入額外套件。 */
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}
